/**
 * The chat's round person mark at the canon's sizes (32 to 64px): the photograph, or the two letters
 * on the inset ground. `AvatarChip` is fixed at the roster's 32px, and the chat draws five sizes.
 */

import photoBox from '~/shared/ui/photoBox.module.css';

import styles from './chat.module.css';

export function ChatAvatar({
  initials,
  avatarUrl,
  size,
}: {
  readonly initials: string;
  readonly avatarUrl: string | null;
  readonly size: 30 | 32 | 36 | 40 | 44 | 60 | 64;
}) {
  const sizeClass = styles[`avatar${String(size)}`];
  if (avatarUrl !== null) {
    return (
      <img
        className={`${String(photoBox.photo)} ${styles.avatar} ${sizeClass ?? ''}`}
        src={avatarUrl}
        alt=""
        decoding="async"
      />
    );
  }
  return (
    <span className={`${styles.avatar} ${sizeClass ?? ''}`} aria-hidden="true">
      {initials}
    </span>
  );
}
